module.exports = __webpack_public_path__ + "media/images/pic/anime/megaphone-2-58f702b48025f5ccb8420fa80a82bd31.svg";